import React from 'react';
import { Link } from 'react-router-dom';

export default function About() {
  const values = [
    {
      icon: '🔬',
      title: 'Scientific Rigor',
      description:
        'Our decisions are driven by evidence-based research and clinical validation from peer-reviewed studies.',
    },
    {
      icon: '🤖',
      title: 'Multimodal AI Innovation',
      description:
        'Pushing boundaries in multimodal AI for healthcare, life sciences, and medical technology.',
    },
    {
      icon: '❤️',
      title: 'Patient First',
      description:
        'We build technologies designed to support earlier detection, deeper disease understanding, and improved patient care.',
    },
    {
      icon: '🌍',
      title: 'Global Impact',
      description:
        'Developing AI-powered intelligence to support healthcare and life sciences across diverse settings worldwide.',
    },
    {
      icon: '🤝',
      title: 'Clinical Collaboration',
      description:
        'Working with clinicians, researchers, and industry partners to validate and advance healthcare AI.',
    },
    {
      icon: '🔒',
      title: 'Trust & Privacy',
      description:
        'Building responsible AI with attention to data security, privacy, provenance, transparency, and governance.',
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-tealLight/30 to-paper text-ink antialiased selection:bg-teal/20 selection:text-ink">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 font-sans">

        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-tealLight border border-teal/20 text-teal text-xs font-semibold uppercase tracking-wider">
              About Us
            </div>
          </div>

          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-sans font-bold leading-tight tracking-tight text-center text-teal">
            About Us
          </h1>

          <p className="mt-6 text-lg sm:text-xl text-inkSoft max-w-3xl mx-auto leading-relaxed text-center">
            Diagnostic Intelligence is an AI Platform for Life Sciences,
            Healthcare & MedTech startup led by AI researcher Ram Samudrala,
            dedicated to advancing medical diagnostics and disease
            intelligence through multimodal AI.
          </p>
        </div>

        {/* Core Values */}
        <div className="mb-16">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 rounded-lg bg-tealLight border border-teal/20 flex items-center justify-center text-lg">
                ⭐
              </span>

              <h2 className="text-2xl font-bold text-ink tracking-tight">
                Our Core Values
              </h2>
            </div>

            <span className="inline-flex items-center gap-1.5 bg-tealLight text-teal text-[10px] font-bold tracking-wider uppercase px-3 py-1.5 rounded-md border border-teal/20">
              <span className="w-1.5 h-1.5 rounded-full bg-teal"></span>
              Guiding Principles
            </span>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {values.map((value, index) => (
              <div
                key={index}
                className="group relative bg-white border border-rule rounded-xl p-6 shadow-[4px_4px_0_0_rgba(20,184,166,0.18)] hover:shadow-[6px_6px_0_0_rgba(20,184,166,0.3)] hover:-translate-y-0.5 hover:-translate-x-0.5 transition-all duration-200"
              >
                <div className="text-4xl mb-4">{value.icon}</div>

                <h3 className="text-lg font-bold text-ink group-hover:text-teal transition-colors mb-2">
                  {value.title}
                </h3>

                <p className="text-sm text-inkSoft leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Buttons */}
        <div className="text-center flex flex-col sm:flex-row items-center justify-center gap-4">

          <Link
            to="/company/roadmap"
            className="inline-flex items-center justify-center bg-teal text-white font-bold px-8 py-3.5 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 transform hover:scale-105"
          >
            Visit Our Roadmap →
          </Link>

          <Link
            to="/company/careers"
            className="inline-flex items-center justify-center bg-teal text-white font-bold px-8 py-3.5 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 transform hover:scale-105"
          >
            Join Our Team →
          </Link>

        </div>

      </div>
    </div>
  );
}
